var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 530,
    y: 259,
    width: 47,
    height: 47
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-530 -259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M564.654 281.544C554.456 281.544 554.456 281.544 554.456 281.544 554.456 271.218 554.456 271.218 554.456 271.218 554.456 270.708 554.074 270.198 553.436 270.198 552.926 270.198 552.416 270.708 552.416 271.218 552.416 281.544 552.416 281.544 552.416 281.544 542.218 281.544 542.218 281.544 542.218 281.544 541.581 281.544 541.198 281.926 541.198 282.564 541.198 283.074 541.581 283.584 542.218 283.584 552.416 283.584 552.416 283.584 552.416 283.584 552.416 293.782 552.416 293.782 552.416 293.782 552.416 294.292 552.926 294.802 553.436 294.802 554.074 294.802 554.456 294.292 554.456 293.782 554.456 283.584 554.456 283.584 554.456 283.584 564.654 283.584 564.654 283.584 564.654 283.584 565.292 283.584 565.802 283.074 565.802 282.564 565.802 281.926 565.292 281.544 564.654 281.544M553.436 260C541.071 260 531 270.071 531 282.564 531 294.929 541.071 305 553.436 305 565.929 305 576 294.929 576 282.564 576 270.071 565.929 260 553.436 260M553.436 302.96C542.218 302.96 533.04 293.782 533.04 282.564 533.04 271.218 542.218 262.04 553.436 262.04 564.782 262.04 573.96 271.218 573.96 282.564 573.96 293.782 564.782 302.96 553.436 302.96",
    fill: "rgb(255,255,255)",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.dc4a725f579646d5c66f407409b53483.svg";
export { ForwardRef as ReactComponent };